<script>
	
	export let label="label"
	export let value=""
	export let readonly=false

	$: viewLabel = () => value!==""

</script>

<span >
	<label for="">{@html viewLabel() ? label : '&nbsp;'}</label>
	<input type="text" bind:value={value} placeholder="{label}" readonly={readonly}>
</span>

<style>
	span{display: flex;flex-flow: column;}
	span>label{font-size: 0.7em;color:#555555;padding-bottom:0.5px;text-transform: capitalize;}
	input{margin-top:0;padding-top:4px;padding-bottom:4px;}
</style>